import { useState, useEffect } from 'react';
import { Box, Button, Flex, Icon } from '@chakra-ui/react';
import {
  MenuRoot,
  MenuTrigger,
  MenuContent,
  MenuItem,
} from '@/components/ui/menu';
import { FaWhatsapp } from 'react-icons/fa';
import { FiChevronDown } from 'react-icons/fi';
import { MdWeb } from 'react-icons/md';
import { RiMapLine } from 'react-icons/ri';
import { FiUsers } from 'react-icons/fi';
import { RangeDatepicker } from 'chakra-dayzed-datepicker';

type PlatformType = 'ALL' | 'WhatsApp' | 'Web' | 'API';

interface FiltersProps {
  startDate: string;
  endDate: string;
  platform: string;
  onFilterChange: (filters: {
    startDate: string;
    endDate: string;
    platform: string;
  }) => void;
}

export default function Filters({
  startDate,
  endDate,
  platform,
  onFilterChange,
}: FiltersProps) {
  // Get today's date in YYYY-MM-DD format for default and max date
  const today = new Date().toISOString().split('T')[0];

  // Use today's date as fallback if startDate or endDate are undefined or invalid
  const safeStartDate = startDate || today;
  const safeEndDate = endDate || today;

  const handlePlatformChange = (newPlatform: PlatformType) => {
    onFilterChange({
      startDate: safeStartDate,
      endDate: safeEndDate,
      platform: newPlatform,
    });
  };

  const getPlatformIcon = (platformName: string) => {
    switch (platformName) {
      case 'WhatsApp':
        return FaWhatsapp;
      case 'Web':
        return MdWeb;
      case 'API':
        return RiMapLine;
      default:
        return FiUsers;
    }
  };

  // Initialize selectedDates with the current start and end dates
  const [selectedDates, setSelectedDates] = useState<Date[]>([
    new Date(safeStartDate),
    new Date(safeEndDate),
  ]);

  const handleDateChange = (dates: Date[]) => {
    setSelectedDates(dates);
    if (dates.length === 2) {
      const startDateFormatted = dates[0].toISOString().split('T')[0];
      const endDateFormatted = dates[1].toISOString().split('T')[0];

      onFilterChange({
        startDate: startDateFormatted,
        endDate: endDateFormatted,
        platform,
      });
    }
  };

  return (
    <Flex borderWidth="1px" borderRadius="md" alignItems="center" p={2}>
      <Box>
        <RangeDatepicker
          selectedDates={selectedDates}
          onDateChange={handleDateChange}
          configs={{
            dateFormat: 'dd/MM/yyyy',
          }}
        />
      </Box>

      <Box borderLeftWidth="1px" height="24px" mx={2} />

      <MenuRoot>
        <MenuTrigger asChild>
          <Button
            variant="ghost"
            _hover={{ bg: 'transparent' }}
            _active={{ bg: 'transparent' }}
            height="40px"
            fontWeight="normal"
          >
            <Icon as={getPlatformIcon(platform)} />
            {platform}
            <FiChevronDown />
          </Button>
        </MenuTrigger>
        <MenuContent>
          <MenuItem value="ALL" onClick={() => handlePlatformChange('ALL')}>
            ALL
          </MenuItem>
          <MenuItem
            value="WhatsApp"
            onClick={() => handlePlatformChange('WhatsApp')}
          >
            WhatsApp
          </MenuItem>
          <MenuItem value="Web" onClick={() => handlePlatformChange('Web')}>
            Web
          </MenuItem>
        </MenuContent>
      </MenuRoot>
    </Flex>
  );
}
